export default __webpack_public_path__ + "static/media/background.6efc1d30.png";